// removed by extract-text-webpack-plugin
module.exports = {"load-data-pane":"load-data-pane__load-data-pane"};


//////////////////
// WEBPACK FOOTER
// ./src/components/load-data-pane/load-data-pane.scss
// module id = 1228
// module chunks = 0